/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import ContactUsModal from '../../../components/ContactUsModal';
import { homesBaseUrlForCommunity } from '../../../constants/globalConstants';
import './CommunityNavigationDialog.css';

const CommunityNavigationDialog = ({
  open,
  onClose,
  communityDetails,
  isAccessible,
  publicView,
  onContactUsOpen,
}) => {
  const [contactUsOpen, setContactUsOpen] = React.useState(false);

  const handleContactUsOpen = () => {
    setContactUsOpen(true);
    onClose(); // Close the navigation dialog when opening contact us
  };

  const handleContactUsClose = () => {
    setContactUsOpen(false);
  };

  const handleNavLinkClick = () => {
    onClose(); // Close dialog when navigation link is clicked
  };

  const navigationItems = [
    {
      condition:
        (isAccessible && !publicView) ||
        communityDetails?.amenities?.length ||
        communityDetails?.ammenitiesInsight?.amenityDesc,
      to: 'Section1',
      label: 'Amenities',
    },
    {
      condition:
        (isAccessible && !publicView) ||
        (communityDetails?.communityVideo?.length &&
          communityDetails?.communityVideo?.find(
            (x) => x.approvedStatus?.toLowerCase() == 'approved',
          )?.id) ||
        (communityDetails?.aboutDesc && communityDetails?.aboutDesc !== ''),
      to: 'Section3',
      label: 'About',
    },
    {
      condition:
        (isAccessible && !publicView) ||
        communityDetails?.healthFacilityCount > 0 ||
        (communityDetails?.healthInsights?.length > 0 &&
          communityDetails?.healthInsights?.[0]?.healthCareDesc !== ''),
      to: 'Section12',
      label: 'Clubs & Connections',
    },
    {
      condition: true, // Jobs is always shown
      to: 'Section5',
      label: 'Jobs',
    },
    {
      condition: true, // Residents is always shown
      to: 'Section6',
      label: 'Residents',
    },
    {
      condition: true, // Cost of Living is always shown
      to: 'Section7',
      label: 'Cost of Living',
    },
    {
      condition: !publicView
        ? true
        : communityDetails?.climate &&
          communityDetails?.climate?.length > 0 &&
          communityDetails?.climate?.[0] &&
          (communityDetails?.climate?.[0]?.climateDesc !== '' ||
            communityDetails?.climate?.[0]?.climateType !== ''),
      to: 'Section8',
      label: 'Climate',
    },
    {
      condition: !publicView
        ? isAccessible ||
          (communityDetails?.gettingAround?.length > 0 &&
            communityDetails?.gettingAround?.[0] &&
            (communityDetails?.gettingAround?.[0]?.dedicatedBikingPaths ||
              communityDetails?.gettingAround?.[0]?.dedicatedWalkingPaths ||
              communityDetails?.gettingAround?.[0]?.regionalAirport ||
              communityDetails?.gettingAround?.[0]?.localAirport ||
              communityDetails?.gettingAround?.[0]?.publicTransType !== '' ||
              communityDetails?.gettingAround?.[0]?.gettingAroundDesc !== ''))
        : isAccessible &&
          communityDetails?.gettingAround?.length > 0 &&
          communityDetails?.gettingAround?.[0] &&
          (communityDetails?.gettingAround?.[0]?.dedicatedBikingPaths ||
            communityDetails?.gettingAround?.[0]?.dedicatedWalkingPaths ||
            communityDetails?.gettingAround?.[0]?.regionalAirport ||
            communityDetails?.gettingAround?.[0]?.localAirport ||
            communityDetails?.gettingAround?.[0]?.publicTransType !== '' ||
            communityDetails?.gettingAround?.[0]?.gettingAroundDesc !== ''),
      to: 'Section9',
      label: 'Getting Around',
    },
    {
      condition: true, // Education is always shown
      to: 'Section10',
      label: 'Education',
    },
    {
      condition:
        (isAccessible && !publicView) ||
        communityDetails?.healthFacilityCount > 0 ||
        (communityDetails?.healthInsights?.length > 0 &&
          communityDetails?.healthInsights?.[0]?.healthCareDesc !== ''),
      to: 'Section11',
      label: 'Healthcare',
    },
  ];

  return (
    <>
      <Dialog
        className="CommunityNavigationDialog"
        open={open}
        onClose={onClose}
        aria-labelledby="community-navigation-dialog-title"
        maxWidth="lg"
        fullWidth
      >
        <MuiDialogTitle id="community-navigation-dialog-title" className="CustomDialogTitle">
          <Box className="FlexCenterStart">
            <Box component="span" className="CommunityBadgeBox" mr={1}>
              {/* <Box component="span" className="CommunityBadgeBox">
                                {cmObj?.isRepresented && <CommunityBadge badgeName="represented" />}
                                {Boolean(isRecommended) && <CommunityBadge badgeName="reccomended" />}
                              </Box> */}
              {/* Rahat Note above is code from CommunityCard.js which import from CommunityBadge.js below I'm just adding image placeholder for now*/}
              <img
                className="BadgeIcon RepresentedBadgeIcon"
                src={require('../../../assets/images/Badge-Icon-White.svg').default}
                alt="Badge Icon"
              />
            </Box>
            <Typography variant="h4" component="h4" className="DialogTitleHeading">
              {communityDetails?.communityNameText}
              {', '}
              {communityDetails?.stateCommunities?.stateShortName}
            </Typography>
          </Box>
          <IconButton className="CustomCloseIcon" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </MuiDialogTitle>

        <MuiDialogContent className="CustomDialogContent">
          <List className="CommunityNavigationList">
            {navigationItems.map(
              (item, index) =>
                item.condition && (
                  <ListItem key={index} className="CommunityNavigationItem">
                    <ScrollLink
                      activeClass="active"
                      to={item.to}
                      spy={true}
                      smooth={true}
                      duration={500}
                      offset={-140}
                      onClick={handleNavLinkClick}
                      style={{ width: '100%', textDecoration: 'none', color: 'inherit' }}
                    >
                      <ListItemText primary={item.label} />
                    </ScrollLink>
                  </ListItem>
                ),
            )}
          </List>
        </MuiDialogContent>

        <MuiDialogActions className="CustomDialogActions">
          <Box className="DialogActionButtons">
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              component={Link}
              href={`${
                communityDetails?.planetReCommunityId
                  ? `${homesBaseUrlForCommunity}${communityDetails.planetReCommunityId}`
                  : ''
              }`}
              target="_blank"
              onClick={onClose}
            >
              View Homes
            </Button>
            <Button variant="contained" color="primary" fullWidth onClick={handleContactUsOpen}>
              Contact Us
            </Button>
          </Box>
        </MuiDialogActions>
      </Dialog>

      <ContactUsModal open={contactUsOpen} onClose={handleContactUsClose} />
    </>
  );
};

export default CommunityNavigationDialog;
